module.exports = __webpack_public_path__ + "static/media/ri.60e96397.png";